import type { OnFarmImplantMatingAllocation } from '@/services/on-farm-implant';

export type MatingBalance = {
  calculatedDegenerates: number;
  difference: number;
  hasCreatedOrDiscarded: boolean;
  hasActivity: boolean;
};

export const getMatingBalance = (
  allocation: OnFarmImplantMatingAllocation | null | undefined,
): MatingBalance | null => {
  if (allocation?.labShipped == null) return null;

  const kept = allocation.onFarmKept ?? 0;
  const onFarmDiscards =
    (allocation.onFarmDiscardedGrade1 ?? 0) +
    (allocation.onFarmDiscardedGrade2 ?? 0) +
    (allocation.onFarmDiscardedGrade3 ?? 0);
  const degenerates = allocation.onFarmDegenerates ?? 0;
  const calculatedDegenerates =
    allocation.labShipped -
    (allocation.heldFrozen ?? 0) -
    kept -
    onFarmDiscards;
  const hasCreatedOrDiscarded = kept + onFarmDiscards > 0;

  return {
    calculatedDegenerates,
    difference: calculatedDegenerates - degenerates,
    hasCreatedOrDiscarded,
    hasActivity: hasCreatedOrDiscarded || degenerates > 0,
  };
};
